import { render, staticRenderFns } from "./InfoMobile.vue?vue&type=template&id=21118676&scoped=true"
import script from "./InfoMobile.vue?vue&type=script&lang=js"
export * from "./InfoMobile.vue?vue&type=script&lang=js"
import style0 from "./InfoMobile.vue?vue&type=style&index=0&id=21118676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21118676",
  null
  
)

export default component.exports